module.exports = __webpack_public_path__ + "static/media/10283.9e53404f.jpg";